import React, { FC, useCallback } from 'react';
import { get, set, kebabCase } from 'lodash';
import { useDispatch } from 'react-redux';
import { updateOptions } from '../../../actions';
import { useOptions } from '../../../selectors';
import { CheckboxWithLabel } from './CheckboxWithLabel';

export interface OptionFieldProps {
  label: string;
  optionPath: string;
  isDisabled?: boolean;
  onChange?: (newState: boolean) => void;
}

export const OptionField: FC<OptionFieldProps> = ({ label, optionPath, isDisabled, onChange }) => {
  const options = useOptions();
  const dispatch = useDispatch();

  const value = get(options, optionPath) as boolean;

  const handleChange = useCallback(() => {
    onChange?.(!value);
    dispatch(updateOptions(set({}, optionPath, !value)));
  }, [onChange, dispatch, optionPath, value]);

  return <CheckboxWithLabel label={label} value={value} onClick={handleChange} isDisabled={isDisabled} fieldId={`option-${kebabCase(optionPath)}`} />;
};
